/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { BillingAddress } from './';
import {
    BillingAddressFromJSON,
    BillingAddressFromJSONTyped,
    BillingAddressToJSON,
} from './';

/**
 * 
 * @export
 * @interface CompanyLegalInformation
 */
export interface CompanyLegalInformation {
    /**
     * 
     * @type {string}
     * @memberof CompanyLegalInformation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyLegalInformation
     */
    registrationNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyLegalInformation
     */
    vatNumber?: string;
    /**
     * 
     * @type {BillingAddress}
     * @memberof CompanyLegalInformation
     */
    address: BillingAddress;
    /**
     * 
     * @type {string}
     * @memberof CompanyLegalInformation
     */
    registrationOfficeInformation?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyLegalInformation
     */
    companySize?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyLegalInformation
     */
    businessSector?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyLegalInformation
     */
    activityArea?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyLegalInformation
     */
    websiteUrl?: string;
}

/**
 * Check if a given object implements the CompanyLegalInformation interface.
 */
export function instanceOfCompanyLegalInformation(value: object): value is CompanyLegalInformation {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('registrationNumber' in value) || value['registrationNumber'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function CompanyLegalInformationFromJSON(json: any): CompanyLegalInformation {
    return CompanyLegalInformationFromJSONTyped(json, false);
}

export function CompanyLegalInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyLegalInformation {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'registrationNumber': json['registrationNumber'],
        'vatNumber': json['vatNumber'] == null ? undefined : json['vatNumber'],
        'address': BillingAddressFromJSON(json['address']),
        'registrationOfficeInformation': json['registrationOfficeInformation'] == null ? undefined : json['registrationOfficeInformation'],
        'companySize': json['companySize'] == null ? undefined : json['companySize'],
        'businessSector': json['businessSector'] == null ? undefined : json['businessSector'],
        'activityArea': json['activityArea'] == null ? undefined : json['activityArea'],
        'websiteUrl': json['websiteUrl'] == null ? undefined : json['websiteUrl'],
    };
}

export function CompanyLegalInformationToJSON(value?: CompanyLegalInformation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'registrationNumber': value['registrationNumber'],
        'vatNumber': value['vatNumber'],
        'address': BillingAddressToJSON(value['address']),
        'registrationOfficeInformation': value['registrationOfficeInformation'],
        'companySize': value['companySize'],
        'businessSector': value['businessSector'],
        'activityArea': value['activityArea'],
        'websiteUrl': value['websiteUrl'],
    };
}

